import React from 'react';

import atob from 'atob';
// import i18n from '../../i18n';
import PropTypes from 'prop-types';
import styles from './Video.module.scss';

const Video = ({ embed, title, preamble }) => {
    if (!embed) {
        return null;
    }

    const markup = { __html: atob(embed.base64) };

    const ratioInPercentage =
        embed.width && embed.height
            ? (embed.height / embed.width) * 100
            : 56.25;

    return (
        <div className={styles['Video']}>
            <div className={styles['Video__Wrapper']}>
                <div className={styles['Video__TextWrapper']}>
                    {title && (
                        <h2 className={styles['Video__Title']}>{title}</h2>
                    )}
                    {preamble && (
                        <p className={styles['Video__Preamble']}>{preamble}</p>
                    )}
                </div>
                <div
                    className={styles['Video__Content']}
                    style={
                        embed.type !== 'rich'
                            ? {
                                  paddingBottom: ratioInPercentage + '%',
                              }
                            : {}
                    }
                    dangerouslySetInnerHTML={markup}
                />
            </div>
        </div>
    );
};

Video.propTypes = {
    embed: PropTypes.object,
    title: PropTypes.string,
};

export default Video;
